import React, { Component } from 'react';
import {connect} from "react-redux";

import * as ActionTypes from "../../actions";

const mapStateToProps = (state) => {
    return {
        facts: state.facts,
        products: state.products
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchProduct: (id) => dispatch(ActionTypes.fetchProduct(id))
    };
};

class ProductConfiguratorAccessoryImage extends Component {

    componentDidMount() {
        const {id, disableRefetch} = this.props;

        if ( ! disableRefetch) {
            this.props.fetchProduct(id);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {id} = this.props;

        if (prevProps.id && prevProps.id !== id) { // ID has changed ...
            this.props.fetchProduct(id);
        }
    }

    showvalueReducer = showvalue => (accumulator, currentValue) => {
        if (currentValue.showvalues.includes(showvalue)) {
            accumulator = currentValue;
        }
        return accumulator;
    };

    blockValueByComparingAttributeValuesReducer = (values, showvalueToGet, showvalueToCompare, value) => (accumulator, currentValue) => {
        const showvalueToGetValue = currentValue.values?.reduce(this.showvalueReducer(showvalueToGet));
        const showvalueToCompareValue = currentValue.values?.reduce(this.showvalueReducer(showvalueToCompare));

        if (showvalueToCompareValue.value.value === value) {
            accumulator = showvalueToGetValue;
        }

        return accumulator;
    };

    getValue(node, showvalue) {
        return node?.values?.reduce(this.showvalueReducer(showvalue), null);
    }

    getBlockValueByComparingAttributeValues(block, showvalueToGet, showvalueToCompare, value) {
        return block?.value?.reduce(this.blockValueByComparingAttributeValuesReducer(block.value, showvalueToGet, showvalueToCompare, value), null);
    }

    getPublicImageUrl(asset) {
        const token = localStorage.getItem('xom_access_token');
        const href = asset?.value[0]?._links[2]?.href;

        return href?.replace('{?mimeType,width,height}', '?access_token=' + token);
    }

    render() {
        const {id, products, facts} = this.props;
        const product = products[id] ? products[id] : false;

        // const image = this.getValue(product, 'pk_produkt_bild');

        const configuratorImageBlock = this.getValue(product, "pk_erdstueck_block");
        const configuratorImage = this.getBlockValueByComparingAttributeValues(configuratorImageBlock, 'pk_erdstueck_bild', 'pk_erdstueck_pos', facts.p_profilhoehe);

        return product && (
            <img alt="" src={this.getPublicImageUrl(configuratorImage)} />
        );

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductConfiguratorAccessoryImage);
